// `usePageContext` allows us to access `pageContext` in any Vue component.
// SEE: https://vike.com/pageContext-anywhere

import type { PageContext } from 'vike/types'
import { type App, type InjectionKey, inject } from 'vue'

const key = Symbol('PageContext') as InjectionKey<PageContext>

export function usePageContext(): PageContext {
  const pageContext = inject(key)
  if (!pageContext) {
    throw new Error(
      'PageContext not found. Make sure to call setPageContext before using usePageContext.'
    )
  }
  return pageContext
}

export function setPageContext(app: App, pageContext: PageContext) {
  app.provide(key, pageContext)
}
